import { formatDate } from "src/utils";
import { CompanyTimeView } from "./components/CompanyTimeView";
import { getTimeZoneCity } from "./helpers/getTimeZoneCity";
import { useCompanyTimeZone } from "./hooks/useCompanyTimeZone";
import { useCurrentTime } from "./hooks/useCurrentTime";

export { CompanyTimeCaption } from "./components/CompanyTimeCaption";
export { useCurrentCompanyTime } from "./hooks/useCurrentCompanyTime";

export const CompanyTime = () => {
  const now = useCurrentTime();
  const { timeZone: companyTimeZone, city: companyTimeZoneCity } = useCompanyTimeZone();
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

  return (
    <CompanyTimeView
      companyTime={formatDate(now, companyTimeZone, "HH:mm")}
      companyTimeZone={companyTimeZone}
      companyTimeZoneCity={companyTimeZoneCity}
      localTime={formatDate(now, localTimeZone, "HH:mm")}
      localTimeZone={localTimeZone}
      localTimeZoneCity={getTimeZoneCity(localTimeZone)}
    />
  );
};
